import { useState } from "react";
import { noRecordsAlert } from "../../../../../../_helpers/Helpers";
import { StudentUsersUIProvider } from "./StudentUsersUIContext";
import { StudentUsersCard } from "./StudentUsersCard";
import { IPListEdit } from "../IP-list-edit/IPListEdit";

export function StudentUsersPage() {
  const [ids, setIds] = useState();
  const [showIPListEdit, setShowIPListEdit] = useState();
  const closeIPListEdit = () => setShowIPListEdit(false);
    
  const studentUsersUIEvents = {
    openIPListEditModal: (ids) => {
      if (typeof ids === 'string') ids = ids.split(",");
              
      if (ids.length < 1) {
        noRecordsAlert();
        return;
      }
      setIds(ids);
      setShowIPListEdit(true);
    }
  };

  return (
    <StudentUsersUIProvider studentUsersUIEvents={studentUsersUIEvents}>
      <IPListEdit
        ids={ids}
        showIPListEdit={showIPListEdit}
        closeIPListEdit={closeIPListEdit}
      />
      <StudentUsersCard />
    </StudentUsersUIProvider>
 );
}